var _defs, _polygon, _line, _line2, _path, _line3, _polygon2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "target-center-monitor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "15.75 23.229 8.25 23.229 9 18.729 15 18.729 15.75 23.229"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6,
    y1: 23.229,
    x2: 18,
    y2: 23.229
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.75,
    y1: 15.729,
    x2: 23.25,
    y2: 15.729
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.919,5.358a2.981,2.981,0,0,1,.331,1.371v9a3,3,0,0,1-3,3H3.75a3,3,0,0,1-3-3v-9a3,3,0,0,1,3-3h6"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.252,
    y1: 9.606,
    x2: 15.08,
    y2: 5.778
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "15.08 5.778 15.493 3.051 17.855 0.729 18.22 2.637 20.128 3.003 17.807 5.365 15.08 5.778"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15,9.729a3.75,3.75,0,1,1-3.75-3.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVmIcon);
export default __webpack_public_path__ + "static/media/VM_Icon.e9a04d0e437af32f0d8c58f0fb39e137.svg";
export { ForwardRef as ReactComponent };